import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  flex: 0 0 48px;
  display: inline-flex;
  justify-content: flex-end;
  height: 24px;
  margin-left: auto;
`;

const BuilderRowActions = ({ children }: IProps) => {
  return <Container>{children}</Container>;
};

export default BuilderRowActions;
